import { gql } from '@apollo/client';

export const UPSERT_INTERVENTION_OVERVIEW = gql`
  mutation UpsertInterventionOverview($input: UpsertInterventionOverviewInput!) {
    intervention: upsertInterventionOverview(input: $input) {
      id
      name
      frameworkResults {
        id
        type
        number
        description
        default {
          id
        }
        level {
          id
          level
        }
        parentResult {
          id
        }
        indicators {
          id
          measurementUnit
          type
          unit
          name
          startDate
          endDate
          target
          targetValue
          description
          resultRelationship
          hasTargets
          hasBaseline
          minValueAllowed
          maxValueAllowed
          dataSources
          outcomeTheme {
            id
            name
          }
          period {
            id
            name
          }
          dimensions {
            id
            index
            name
            options
          }
          benchmarks {
            id
            index
            name
            description
            benchmark {
              id
              name
              description
            }
          }
          periods {
            id
            periodDate
            periodNumber
            label
          }
          targets {
            id
            value
            periodDate
            periodNumber
            dimensionOptions
          }
        }
      }
    }
  }
`;

export const UPSERT_INTERVENTION_INDICATORS = gql`
  mutation UpsertInterventionIndicators($input: UpsertInterventionIndicatorsInput!) {
    intervention: upsertInterventionIndicators(input: $input) {
      id
    }
  }
`;

export const UPSERT_INTERVENTION_MONITORING = gql`
  mutation UpsertInterventionMonitoring($input: UpsertInterventionMonitoringInput!) {
    intervention: upsertInterventionMonitoring(input: $input) {
      id
    }
  }
`;
